import { z } from 'zod'

export const updateGeneralInformationContactSchema = z.object({
  general_information: z.object({
    phone: z.object({
      number: z.string().optional().nullable(),
      kind: z.string().optional().nullable(),
      whatsapp_capable: z.string().optional().nullable()
    })
  })
})

export type UpdateGeneralInformationContactValidationSchema = z.infer<typeof updateGeneralInformationContactSchema>
